import React, { useEffect, useState } from 'react';
import { Box } from '@mui/material';
import { Controller, SubmitHandler, useForm } from 'react-hook-form';

import {
  CtaButton,
  DatePickerInput,
  ModalContainer,
  TextInput,
} from '@tassomutuo-backoffice/ui';
import { Lead } from '@tassomutuo-backoffice/types';

interface IFormInputs {
  appointmentDate: Date | null;
  appointmentTime: string | null;
  appointmentLocation: string;
}

interface IProps {
  open: boolean;
  handleClose: () => void;
  lead?: Lead;
  updateAppointment: (data: {
    appointmentDate: Date;
    appointmentTime: string;
    appointmentLocation: string;
  }) => Promise<void>;
}
const ModalLeadAppointmentForm = ({
  open,
  handleClose,
  lead,
  updateAppointment,
}: IProps) => {
  const {
    handleSubmit,
    formState: { errors },
    control,

    reset,
  } = useForm<IFormInputs>({
    defaultValues: {
      appointmentDate: lead?.properties.appointment_date
        ? new Date(lead?.properties.appointment_date)
        : null,
      appointmentTime: lead?.properties.appointment_hour || '',
      appointmentLocation: lead?.properties.appointment_location || '',
    },
  });

  useEffect(() => {
    if (lead) {
      reset({
        appointmentDate: lead?.properties.appointment_date
          ? new Date(lead?.properties.appointment_date)
          : null,
        appointmentTime: lead?.properties.appointment_hour || '',
        appointmentLocation: lead?.properties.appointment_location || '',
      });
    }
  }, [lead]);

  const [isLoading, setIsLoading] = useState(false);

  const onCloseHandler = () => {
    handleClose();
    reset({});
  };

  const onSubmit: SubmitHandler<IFormInputs> = async (data) => {
    const { appointmentDate, appointmentTime, appointmentLocation } = data;
    try {
      setIsLoading(true);
      if (appointmentTime && appointmentDate) {
        await updateAppointment({
          appointmentDate,
          appointmentTime,
          appointmentLocation,
        });
        onCloseHandler();
      }
    } finally {
      setIsLoading(false);
    }
  };
  return (
    <ModalContainer
      open={open}
      handleClose={onCloseHandler}
      title="Aggiorna appuntamento"
    >
      <form onSubmit={handleSubmit(onSubmit)}>
        <Box width="100%" maxWidth="400px">
          <Controller
            control={control}
            name="appointmentDate"
            rules={{
              required: 'Campo obbligatorio',
            }}
            render={({ field: { onChange, value } }) => (
              <DatePickerInput
                disabled={false}
                label="Data"
                value={value}
                onChangeValue={onChange}
                helperText={errors?.appointmentDate?.message}
                error={!!errors?.appointmentDate}
              />
            )}
          />
          <Controller
            control={control}
            name="appointmentTime"
            rules={{
              required: 'Campo obbligatorio',
            }}
            render={({ field }) => (
              <TextInput
                type="time"
                label="Ora"
                helperText={errors?.appointmentTime?.message}
                error={!!errors?.appointmentTime}
                {...field}
              />
            )}
          />
          <Controller
            control={control}
            name="appointmentLocation"
            rules={{
              required: 'Campo obbligatorio',
            }}
            defaultValue={lead?.properties.appointment_location}
            render={({ field }) => (
              <TextInput
                type="text"
                label="Luogo"
                helperText={errors?.appointmentLocation?.message}
                error={!!errors?.appointmentLocation}
                {...field}
              />
            )}
          />

          <Box display="flex" justifyContent="center" mt={4}>
            <CtaButton variant="contained" type="submit" loading={isLoading}>
              SALVA
            </CtaButton>
          </Box>
        </Box>
      </form>
    </ModalContainer>
  );
};

export default ModalLeadAppointmentForm;
